import {
    all, select, takeLatest,
} from 'redux-saga/effects';

import Scopes from '../../constants/Scopes';
import { getScopeSelector } from '../../commons/reduxModules/Authentication';
import gtmInit from '../trackers/gtm';
import hotjarInit from '../trackers/hotjar';

import {
    INIT_CMP_APP,
} from '../reduxModules/ConsentManagementPlatform';

export function* callAction() {
    const scope = yield select(getScopeSelector);
    if (scope !== Scopes.PRO) return;
    yield all([
        gtmInit(),
        hotjarInit(),
    ]);
}

export function* watch() {
    yield takeLatest(INIT_CMP_APP, callAction);
}
